module.exports = __webpack_public_path__ + "img/curve-down.9630b773.svg";